export default {
    noRecordsYet: 'No records yet',
}
